import { useLocation, useNavigate } from 'react-router-dom'
import { images } from '../services/images.service'
import { motion, AnimatePresence } from 'framer-motion'
import { openLogin, openSignUp } from '../store/slices/ui.slice'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../store/slices/user.slice'
import { Button } from './ui/elements'

export function HamburgerMenu({
  isMenuOpen,
  toggleMenu,
  toggleLightMode,
  isLightMode,
  menuItems,
  handleLogout,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const loggedInUser = useSelector((state) => state.userModule.loggedInUser)

  const handleMenuItemClick = (href) => {
    navigate(href)
    toggleMenu()
  }

  return (
    <AnimatePresence>
      {isMenuOpen && (
        <>
          {/* רקע שקוף עם אנימציית fade-in/out */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={toggleMenu}
          />

          {/* תפריט צדדי עם אנימציית slide-in/out */}
          <motion.div
            className="fixed top-0 left-0 bg-secondaryBackground border-r-2 border-red-500 p-4 min-h-screen w-[90%] md:w-[50%] z-50 flex flex-col"
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            {/* כותרת עם כפתור סגירה */}
            <div className="flex justify-between items-center">
              <button
                onClick={toggleLightMode}
                className="flex gap-2 items-center"
              >
                {/* כאן ניתן להוסיף כפתור למצב מואר/כהה */}
              </button>
              <button
                onClick={toggleMenu}
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={images.closeMenu}
                  alt="Close Menu"
                  className="h-8 w-8"
                />
              </button>
            </div>

            {/* אזור משתמש מחובר */}
            {loggedInUser && (
              <motion.div
                className="flex items-center justify-between mt-4"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                <button
                  onClick={toggleMenu}
                  className="flex items-center gap-2"
                >
                  <img
                    src={loggedInUser.image || images.defaultUserIcon}
                    alt="User Avatar"
                    className="h-12 w-12 rounded-full object-cover border border-primary"
                  />
                  <span className="text-softText text-xl">
                    {loggedInUser.nickname}
                  </span>
                </button>
                <Button
                  text="התנתקות"
                  width={100}
                  height={40}
                  fontSize="text-lg"
                  textColor="text-white"
                  bgColor="fill-primary" // או מה שהכפתור login שלך דורש
                  onClick={handleLogout}
                  aria-label="התנתק מהחשבון"
                  title="התנתקות מאניזון"
                />
              </motion.div>
            )}

            {/* תפריט ניווט */}
            <motion.ul
              className="space-y-2 md:space-y-4 text-right text-softText mt-8 md:mt-24"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {menuItems.map((item, index) => (
                <motion.li
                  key={item.id}
                  className="text-2xl leading-relaxed"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                >
                  <button
                    onClick={() => handleMenuItemClick(item.href)}
                    className="block hover:text-primary transition-colors"
                  >
                    {item.name}
                  </button>
                </motion.li>
              ))}
            </motion.ul>

            {/* כפתורי התחברות/הרשמה עבור משתמשים שאינם מחוברים */}
            {!loggedInUser && (
              <motion.div
                className="flex flex-col gap-4 items-center mt-auto"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <Button
                  text="התחברות"
                  width={230}
                  height={60}
                  fontSize="text-lg"
                  textColor="text-softText"
                  bgColor="fill-[#363636]"
                  onClick={() => {
                    dispatch(openLogin())
                    toggleMenu()
                  }}
                  aria-label="התחבר לחשבון שלך"
                  title="התחברות"
                />

                <Button
                  text="הרשמה"
                  width={230}
                  height={60}
                  fontSize="text-md"
                  textColor="text-white"
                  bgColor="fill-primary"
                  onClick={() => {
                    dispatch(openSignUp())
                    toggleMenu()
                  }}
                  icon="https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/registericon-1747116827122.svg"
                  aria-label="הירשם לאתר אניזון"
                  title="הרשמה"
                />
              </motion.div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
